import { format } from "date-fns";

export default {
  methods: {
    humanDate(date, formatString) {
      return date !== undefined && date !== null
        ? format(
            new Date(date),
            formatString !== undefined ? formatString : "dd MMM - HH:mm"
          )
        : "N/A";
    },

    timeFromDays(days) {
      return days * 24 * 60 * 60 * 1000;
    },

    timeFromHours(hours) {
      return hours * 60 * 60 * 1000;
    },

    timeFromMinutes(minutes) {
      return minutes * 60 * 1000;
    },

    timeWithinMinutes(date1, minutes, date2) {
      if (date2 == undefined) date2 = new Date();
      return date2 - new Date(date1) < this.timeFromMinutes(minutes);
    },

    timeWithinHours(date, hours) {
      return new Date() - new Date(date) < this.timeFromHours(hours);
    },

    timeWithinDays(date, days) {
      return new Date() - new Date(date) < this.timeFromDays(days);
    },
  },
};
